export enum HolidayDbStatus {
    ToBeValidated = 1,
    Validated = 2,
    Refused = 3
}
